// extracted by mini-css-extract-plugin
export var icon = "bio-module--icon--1OkBa";
export var name = "bio-module--name--CdDoD";
export var description = "bio-module--description--3KgiH";
export var links = "bio-module--links--1U2_b";
export var twitter = "bio-module--twitter--1nXAa";
export var github = "bio-module--github--TrZ8e";
export var speakerdeck = "bio-module--speakerdeck--2C88t";